var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['lang-btn', 'iconfont', _vm.isLanguageForZh ? 'iconzhongwen': 'iconyingwen'],on:{"click":_vm.changeLang}})}
var staticRenderFns = []

export { render, staticRenderFns }